export default "__VITE_ASSET__D$$nAWRf__"